export default __webpack_public_path__ + "src/assets/keplr.826cf095efe67e19bedf86db4dd4f28e.svg";